import React, { useMemo, useEffect } from 'react';
import { connect } from 'react-redux';
import api from '../api';
import PropTypes from 'prop-types';
import { translate } from 'react-polyglot';
import Modal from './Modal';
import { SecondaryButton } from './buttons';
import './ProfileDeleteModal.css';

function ProfileDeleteModal(props) {
  const {
    isOpen,
    isCurrentProfile,
    isLoading,
    onCancel,
    onConfirm,
    profileId,
    t,
    error,
    resetDeleteState
  } = props;

  useEffect(() => {
    resetDeleteState();
  }, [profileId, resetDeleteState]);

  const modalCopy = useMemo(() => {
    if (error) {
      return <p className="profile-delete-modal__error">{error.message}</p>;
    }
    if (isCurrentProfile) {
      return <p>{t('profile.deleteCurrentMessage')}</p>;
    }
    return (
      <React.Fragment>
        <p className="profile-delete-modal__confirmation">
          {t('profile.deleteConfirmation')}
        </p>
        <p>{t('profile.deleteWarning')}</p>
      </React.Fragment>
    );
  }, [error, isCurrentProfile, t]);

  return (
    <Modal
      className="profile-delete-modal"
      isOpen={isOpen}
      showCloseButton={false}
      onRequestClose={onCancel}
    >
      {modalCopy}

      {isCurrentProfile || error ? (
        <div className="profile-delete-modal__actions profile-delete-modal__actions--single">
          <SecondaryButton
            colorScheme="blue"
            disabled={isLoading}
            type="button"
            onClick={onCancel}
          >
            {t('profile.deleteCurrentCancel')}
          </SecondaryButton>
        </div>
      ) : (
        <div className="profile-delete-modal__actions">
          <SecondaryButton
            colorScheme="blue"
            disabled={isLoading}
            type="button"
            onClick={onCancel}
          >
            {t('profile.deleteCancel')}
          </SecondaryButton>
          <SecondaryButton
            colorScheme="red"
            disabled={isLoading || error}
            loading={isLoading}
            type="button"
            onClick={() => {
              onConfirm(profileId);
            }}
          >
            {t('profile.deleteConfirm')}
          </SecondaryButton>
        </div>
      )}
    </Modal>
  );
}

ProfileDeleteModal.defaultProps = {
  error: null
};

ProfileDeleteModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  isCurrentProfile: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  profileId: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
  error: PropTypes.shape({
    message: PropTypes.string
  }),
  resetDeleteState: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  error: state.profilesDelete.error
});

const mapDispatchToProps = dispatch => ({
  resetDeleteState: () => dispatch(api.actions.profilesDelete.reset())
});

export default translate()(
  connect(mapStateToProps, mapDispatchToProps)(ProfileDeleteModal)
);



// WEBPACK FOOTER //
// ./src/components/ProfileDeleteModal.js